var React = require('react');

function ArrowInline (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Misc","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd"},React.createElement("g",{"id":"arrow","fill":"currentColor","fillRule":"nonzero"},React.createElement("path",{"d":"M10.1280781,5.25 L6.3562932,1.64965985 L7.39200682,0.564626532 L13.0862076,6 L7.39200682,11.4353735 L6.3562932,10.3503402 L10.1280781,6.75 L0.409179688,6.75 L0.409179688,5.25 L10.1280781,5.25 Z"}))));
}

ArrowInline.defaultProps = {"width":"13px","height":"12px","viewBox":"0 0 13 12","version":"1.1"};

module.exports = ArrowInline;

ArrowInline.default = ArrowInline;
